const AdminAddressEndpoint = {
  getState: {
    url: "/states",
    method: "GET",
  },
  getCity: {
    url: "/city",
    method: "GET",
  },
};

export default AdminAddressEndpoint;
